import { MenuItem, Stack, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CONSTANTS from '../../Constants'

import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'

import { objectToQueryString } from '../../Helpers/Util'
import { useAppDispatch } from '../../Store/Hooks'
import { getAssociatedUsers } from '../../Store/Slice/user.slice'
import MUIDateTimePicker from '../MUIDateTimePicker'
import { MUIAutocompleteMultiSelect, MUIMultiselectAsset } from '../Shared'
import ConfirmDialog from '../Shared/Dialog/ConfirmDialog'

const conditionOptions = [
  { label: 'Is equal to', value: 'equals' },
  { label: 'Is not equal to', value: 'notEquals' },
  { label: 'Is greater than', value: 'greaterThan' },
  { label: 'Is greater than or equal to', value: 'greaterThanEquals' },
  { label: 'Is less than', value: 'lessThan' },
  { label: 'Is less than or equal to', value: 'lessThanEquals' },
  { label: 'In between', value: 'between' },
]

const bultOperationType = [
  { value: 'BULK_STATE_CHANGE', label: 'BULK_STATE_CHANGE' },
  { value: 'BULK_UPDATE', label: 'BULK_UPDATE' },
  { value: 'INTERACTIVE_BULK_UPDATE', label: 'INTERACTIVE_BULK_UPDATE' },
  { value: 'BULK_UPDATE_TRANSCODING', label: 'Bulk Re-Transcoding' },
]
export const JOB_TYPE_DISPLAY_VALUES: Record<string, string> = {
  BULK_STATE_CHANGE: 'State Change',
  BULK_UPDATE: 'CSV Based Update',
  INTERACTIVE_BULK_UPDATE: 'Interactive Update',
  BULK_UPDATE_TRANSCODING: 'Bulk Re-Transcoding',
}
interface BulkOperationsExportProps {
  open: boolean
  onCancel: () => void
  onExport: (data: any) => void
}

const BulkOperationsExport: React.FC<BulkOperationsExportProps> = ({
  open,
  onCancel,
  onExport,
}) => {
  const [condition, setCondition] = useState('equals')
  const [date, setDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [userName, setUserName] = useState({ newValue: [] })
  const [bulkType, setBulkType] = useState<any>({ newValue: [] })
  const [allUsersState, setAllUsersState] = useState([])
  const dispatch = useAppDispatch()

  const resetValues = () => {
    setCondition('equals')
    setDate(null)
    setEndDate(null)
    setUserName({ newValue: [] })
    setBulkType({ newValue: [] })
  }
  const getUsers = async () => {
    let params = {
      page: 1,
      limit: 1000,
      sortBy: 'userName',
      sortType: 1,
    }
    params = objectToQueryString(params)
    const { payload = {} } = await dispatch(getAssociatedUsers(params) as any)
    const { data = {} } = payload
    const resUser: any = []
    data?.records?.forEach((user: any) => {
      resUser.push({ label: user.userName, value: user.userName })
    })
    setAllUsersState(resUser)
  }

  useEffect(() => {
    getUsers()
  }, [])

  const handleExport = async () => {
    const jobFilters = []

    if (date) {
      if (condition === 'between' && endDate) {
        jobFilters.push({
          filterBy: 'scheduleDate',
          filterValue: new Date(date).toISOString(),
          filterValueTo: new Date(endDate).toISOString(),
          filterCondition: 'between',
        })
      } else {
        jobFilters.push({
          filterBy: 'scheduleDate',
          filterValue: new Date(date).toISOString(),
          filterCondition: condition,
        })
      }
    }
    if (userName?.newValue?.length) {
      jobFilters.push({
        filterBy: 'userName',
        filterValue: userName?.newValue?.map((ele: any) => ele.value),
        filterCondition: 'in',
      })
    }
    if (bulkType?.newValue?.length) {
      jobFilters.push({
        filterBy: 'jobType',
        filterValue: bulkType?.newValue?.map((ele: any) => ele.value),
        filterCondition: 'in',
      })
    }
    const payload = {
      jobFilters,
      limit: 0,
    }
    const requestedData: any = API_CONFIG(API_LIST.EMAIL_REPORT.EXPORT_REPORT_LIST, payload)
    const result = await mainApiService(requestedData)
    result?.responseCode === 200 && resetValues()
    onExport(result)
  }

  const checkDisableState = () => {
    if (date !== null || userName?.newValue?.length > 0 || bulkType?.newValue?.length > 0) {
      return false
    }
    return true
  }

  return (
    <ConfirmDialog
      open={open}
      title={'Export Data'}
      description={
        ' Select filters to export specific bulk operations data. At least one filter is required to proceed.'
      }
      icon={'DeleteRolePriIcon'}
      btn1Label={CONSTANTS.BTN_LABEL_CANCEL}
      btn2Label={CONSTANTS.BTN_LABEL_EXPORT}
      btn2Disabled={checkDisableState()}
      btn2Color={'primary'}
      onClose={() => {
        onCancel()
        resetValues()
      }} // Added onClose prop
      onConfirm={handleExport}
      extraUI={
        <Stack spacing={2} mt={1} mb={2}>
          <TextField
            select
            label='Job Start Time'
            value={condition}
            onChange={(e) => setCondition(e.target.value)}
            fullWidth
          >
            {conditionOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <MUIDateTimePicker
            label={condition === 'between' ? 'From' : 'Value'}
            type='datetime'
            value={date}
            onChange={setDate}
            views={CONSTANTS.DATE_TIME_FORMAT_VIEWS as any}
            name='fromDate'
            error=''
            placement='right'
          />

          {condition === 'between' && (
            <MUIDateTimePicker
              label={'To'}
              type='datetime'
              value={endDate}
              onChange={setEndDate}
              views={CONSTANTS.DATE_TIME_FORMAT_VIEWS as any}
              name='endDate'
              error=''
              placement='right'
            />
          )}

          <MUIAutocompleteMultiSelect
            usingFor='operationType'
            width='100%'
            label='User Name'
            options={allUsersState}
            error={{}}
            labelKey='label'
            name='operationType'
            value={userName.newValue}
            onInputChange={(_ev: any, newValue: any) => {
              setUserName((prev: any) => ({ ...prev, newValue }))
            }}
            selectAll
          />
          <MUIMultiselectAsset
            name={'operationType'}
            className='autocomple-class'
            multiple={true}
            label={'Bulk Operation Type'}
            options={bultOperationType}
            error={{}}
            onInputChange={(_ev: any, newValue: any) => {
              setBulkType((prev: any) => ({ ...prev, newValue }))
            }}
            id={'operationType'}
            value={bulkType.newValue}
            labelKey={'label'}
            required={false}
          />
        </Stack>
      }
    />
  )
}

export default BulkOperationsExport
